export const Color = {
	primary: "#465578",
	primary75: "#ACBEE8",
	primary50: "#46557880",
	primary15: "#46557826",
	primary05: "#4655780d",

	secondary: "#80c2ff",
	secondaryHover: "#7fc2ffb3",
	tertiary: "#6b63fecc",
	tertiaryHover: "#c1bdff",
	quaternary: "#5a87c8",
	background: "#fcfdff",
	white: "#ffff",
	lightgray: "#bebebe",
	gray: "#888888b3",
	safe: "forestgreen",
	royal: "royalblue",
	danger: "#d32f2f",
	fieldGray: "#00000080",
	textPrimary: "#425070",
	textSecondary: "#425070",
	textTertiary: "#425070",
	textFooter: "#fff",
	footerBackground: "#425070",
	disabled: "#ddd",
	colorDisabled: "#ddd",
	buttonSwapColor: "#ddd",
	warning: "#ff8800e6",
	success: "#4caf50e6",
	error: "#d32f2f",
	info: "#415f9be6",
	transparent: "#00000000"
}

export default Color
